export enum FrequencyEnum {
  BD = "bd",
  NOCTE = "nocte",
  TDS = "tds",
  AM = "am",
  QDS = "qds",
  PRN = "prn",
  NN = "nn",
  MN = "mn",
  PM = "pm",
  OW = "ow",
  BW = "bw",
  OM = "om",
  BM = "bm",
}

export const isValidFrequency = (value: string): value is FrequencyEnum => {
  return Object.values(FrequencyEnum).includes(value as FrequencyEnum);
};

export const FrequencyFriendlyNameMapping = {
  [FrequencyEnum.BD]: "Twice a day",
  [FrequencyEnum.NOCTE]: "Night",
  [FrequencyEnum.TDS]: "Three times a day",
  [FrequencyEnum.AM]: "Morning",
  [FrequencyEnum.QDS]: "Four times daily",
  [FrequencyEnum.PRN]: "As needed",
  [FrequencyEnum.NN]: "Noon",
  [FrequencyEnum.MN]: "Morning and Noon",
  [FrequencyEnum.PM]: "Evening",
  [FrequencyEnum.OW]: "Weekly",
  [FrequencyEnum.BW]: "Bi-Weekly",
  [FrequencyEnum.OM]: "Once a Month",
  [FrequencyEnum.BM]: "Bi-Monthly",
};

export const FrequencyAcronymMapping = {
  [FrequencyEnum.BD]: "BD",
  [FrequencyEnum.NOCTE]: "NOCTE",
  [FrequencyEnum.TDS]: "TDS",
  [FrequencyEnum.AM]: "AM",
  [FrequencyEnum.QDS]: "QDS",
  [FrequencyEnum.PRN]: "PRN",
  [FrequencyEnum.NN]: "NN",
  [FrequencyEnum.MN]: "MN",
  [FrequencyEnum.PM]: "PM",
  [FrequencyEnum.OW]: "W",
  [FrequencyEnum.BW]: "BW",
  [FrequencyEnum.OM]: "OM",
  [FrequencyEnum.BM]: "BM",
};

export const FrequencyTimeMapping = {
  morning: [
    FrequencyEnum.BD,
    FrequencyEnum.TDS,
    FrequencyEnum.PRN,
    FrequencyEnum.QDS,
    FrequencyEnum.AM,
    FrequencyEnum.MN,
  ],
  noon: [
    FrequencyEnum.TDS,
    FrequencyEnum.PRN,
    FrequencyEnum.QDS,
    FrequencyEnum.NN,
    FrequencyEnum.MN,
  ],
  evening: [
    FrequencyEnum.BD,
    FrequencyEnum.TDS,
    FrequencyEnum.PRN,
    FrequencyEnum.QDS,
    FrequencyEnum.PM,
  ],
  night: [FrequencyEnum.NOCTE, FrequencyEnum.QDS],
};

export const FrequencyGroups = Object.keys(FrequencyTimeMapping);

export const FrequencyDropdownOptions = [
  {
    value: FrequencyEnum.AM,
    label: `${FrequencyFriendlyNameMapping[FrequencyEnum.AM]} (${FrequencyEnum.AM.toUpperCase()})`,
  },
  {
    value: FrequencyEnum.NN,
    label: `${FrequencyFriendlyNameMapping[FrequencyEnum.NN]} (${FrequencyEnum.NN.toUpperCase()})`,
  },
  {
    value: FrequencyEnum.MN,
    label: `${FrequencyFriendlyNameMapping[FrequencyEnum.MN]} (${FrequencyEnum.MN.toUpperCase()})`,
  },
  {
    value: FrequencyEnum.PM,
    label: `${FrequencyFriendlyNameMapping[FrequencyEnum.PM]} (${FrequencyEnum.PM.toUpperCase()})`,
  },
  {
    value: FrequencyEnum.NOCTE,
    label: `${FrequencyFriendlyNameMapping[FrequencyEnum.NOCTE]} (${FrequencyEnum.NOCTE.toUpperCase()})`,
  },
  {
    value: FrequencyEnum.BD,
    label: `${FrequencyFriendlyNameMapping[FrequencyEnum.BD]} (${FrequencyEnum.BD.toUpperCase()})`,
  },
  {
    value: FrequencyEnum.TDS,
    label: `${FrequencyFriendlyNameMapping[FrequencyEnum.TDS]} (${FrequencyEnum.TDS.toUpperCase()})`,
  },
  {
    value: FrequencyEnum.QDS,
    label: `${FrequencyFriendlyNameMapping[FrequencyEnum.QDS]} (${FrequencyEnum.QDS.toUpperCase()})`,
  },
  {
    value: FrequencyEnum.PRN,
    label: `${FrequencyFriendlyNameMapping[FrequencyEnum.PRN]} (${FrequencyEnum.PRN.toUpperCase()})`,
  },
  {
    value: FrequencyEnum.OW,
    label: `${FrequencyFriendlyNameMapping[FrequencyEnum.OW]} (${FrequencyAcronymMapping[FrequencyEnum.OW]})`,
  },
  {
    value: FrequencyEnum.BW,
    label: `${FrequencyFriendlyNameMapping[FrequencyEnum.BW]} (${FrequencyEnum.BW.toUpperCase()})`,
  },
  {
    value: FrequencyEnum.OM,
    label: `${FrequencyFriendlyNameMapping[FrequencyEnum.OM]} (${FrequencyEnum.OM.toUpperCase()})`,
  },
  {
    value: FrequencyEnum.BM,
    label: `${FrequencyFriendlyNameMapping[FrequencyEnum.BM]} (${FrequencyEnum.BM.toUpperCase()})`,
  },
];
